import { useAuthKit } from '../contexts/AuthProvider';

export type CurrentUser = {
  name: string;
  firstName: string;
  role: string;
  initials: string;
  orgId: string;
  email: string;
};

function initialsFrom(first: string | null, last: string | null, email: string): string {
  const fi = (first?.[0] ?? '').toUpperCase();
  const li = (last?.[0] ?? '').toUpperCase();
  if (fi && li) return fi + li;
  if (fi) return fi;
  if (li) return li;
  return email.slice(0, 2).toUpperCase();
}

export function useAuth(): CurrentUser {
  const { user, role, organizationId } = useAuthKit();
  if (!user) {
    throw new Error(
      'useAuth() called before authentication. Components that read user must render under AuthGate.',
    );
  }
  const name =
    [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || user.email;
  const firstName = user.firstName?.trim() || user.email.split('@')[0] || 'there';
  return {
    name,
    firstName,
    email: user.email,
    role: role ?? 'User',
    initials: initialsFrom(user.firstName, user.lastName, user.email),
    orgId: organizationId ?? '',
  };
}
